<div class="row row-sm add-form">
    <form autocomplete="off" class="p-0" novalidate [formGroup]="FacultyForm ">
        <div class="col-lg-12 col-md-12">
            <div class="card-body">
                <div class="bc d-flex align-items-center pl-3" *ngIf="submitButton">
                    <img alt="Logo" src="../../assets/img/FacultyMaster.png" class="mh-40px pb-2">
                    <div class="ml-2">
                        <h3 class="main-content-label mb-1"><b>
                            {{'header.faculty-data.titleList.Faculty' | translate}}
                            </b></h3>
                        <p class="text-muted card-sub-title mb-0">
                            {{'header.faculty-data.titleList.AddNewFacultyRecord' | translate}}
                        </p>
                    </div>
                </div>
                <div class="bc d-flex align-items-center pl-3" *ngIf="editButton">
                    <img alt="Logo" src="../../assets/img/FacultyMaster.png" class="mh-40px pb-2">
                    <div class="ml-2">
                        <h3 class="main-content-label mb-1"><b>
                            {{'header.faculty-data.titleList.Faculty' | translate}}
                            </b></h3>
                        <p class="text-muted card-sub-title mb-0">
                            {{'header.faculty-data.titleList.UpdateFacultyRecord' | translate}}
                        </p>
                    </div>
                </div>
                <div class="bc d-flex align-items-center pl-3" *ngIf="deleteButton">
                    <img alt="Logo" src="../../assets/img/FacultyMaster.png" class="mh-40px pb-2">
                    <div class="ml-2">
                        <h3 class="main-content-label mb-1"><b>
                            {{'header.faculty-data.titleList.Faculty' | translate}}
                            </b></h3>
                        <p class="text-muted card-sub-title mb-0">
                            {{'header.faculty-data.titleList.DeleteFacultyRecord' | translate}}
                        </p>
                    </div>
                </div>
                <hr>
                <div class="row clearfix">
                    <div class="col-sm-6">
                        <div class="form-group">
                            <div class="">
                                <mat-form-field appearance="outline" class="example-full-width">
                                    <mat-label>{{'header.faculty-data.titleList.FacultyCode' | translate}}</mat-label>
                                    <input appUppercase onkeydown="return (event.keyCode!=13);" [readonly]="isread || isreaddelete"
                                        maxlength="5" class="color" matInput formControlName="FcCode"
                                        placeholder="Faculty Code" required>
                                    <mat-error class="margin_tp"
                                        *ngIf="FacultyForm.controls['FcCode'].touched && FacultyForm.controls['FcCode'].errors?.required">
                                        Mandatory
                                    </mat-error>
                                    <mat-error class="margin_tp"
                                        *ngIf="FacultyForm.controls['FcCode'].touched && FacultyForm.controls['FcCode'].errors?.pattern">
                                        Invalid
                                    </mat-error>
                                </mat-form-field>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <div class="form-group">
                            <div class="">
                                <mat-form-field appearance="outline" class="example-full-width">
                                    <mat-label>{{'header.faculty-data.titleList.FacultyName' | translate}}</mat-label>
                                    <input appCamelcase maxlength="60" onkeydown="return (event.keyCode!=13);"
                                        [readonly]="isreaddelete" class="color" matInput formControlName="FcDesc"
                                        placeholder="Faculty Name" required >
                                    <mat-error class="margin_tp"
                                        *ngIf="FacultyForm.controls['FcDesc'].touched && FacultyForm.controls['FcDesc'].errors?.required">
                                        Mandatory
                                    </mat-error>
                                    <mat-error class="margin_tp"
                                        *ngIf="FacultyForm.controls['FcDesc'].touched && FacultyForm.controls['FcDesc'].errors?.pattern">
                                        Invalid
                                    </mat-error>
                                </mat-form-field>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-12 row ">
                        <div class="col-sm-12 prpl">
                            <button id="Save" type="button" *ngIf="submitButton && FacultyCreate" 
                            class="btn btn-primary btn-icon-text floatright mt-1"
                            (click)="submit()">
                            <span style="display: contents; align-items: center;">
                                <img width="20vh" src="../../assets/img/save.gif" style="margin-right: 5px;">
                                {{'header.faculty-data.titleList.Save'
                                | translate}}
                            </span>
                        </button>
                        <button id="Update" type="button" *ngIf="editButton && FacultyUpdate" 
                        class="btn btn-primary btn-icon-text floatright mt-1"
                        (click)="update()">
                        <span style="display: contents; align-items: center;">
                            <img width="20vh" src="../../assets/img/edit1.gif" style="margin-right: 5px;">
                            {{'header.faculty-data.titleList.Update'
                                | translate}}
                        </span>
                    </button>
                    <button id="Delete" type="button" *ngIf="deleteButton && FacultyDelete" 
                    class="btn btn-primary btn-icon-text floatright mt-1"
                                (click)="DeletetheRecord()">
                                <span style="display: contents; align-items: center;">
                                    <img width="20vh" src="../../assets/img/trash.gif" style="margin-right: 5px;">
                                    {{'header.faculty-data.titleList.Delete'
                                | translate}}
                                </span>
                            </button>
                            <button id="Back" type="button" [mat-dialog-close]="true"
                            class="btn btn-primary btn-icon-text floatright mr-3 mt-1">
                            <span style="display: contents; align-items: center;">
                                <img width="20vh" src="../../assets/img/turn-left.gif" style="margin-right: 7px;">
                                {{'header.faculty-data.titleList.Back'
                                | translate}}
                            </span>
                        </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>